import _regeneratorRuntime from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import request from "@/utils/request";
export default {
  prefix: "/system/message/",
  //首页拉取消息
  homeMessage: function () {
    var _homeMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(data, limit) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", request({
              showMask: true,
              url: process.env.VUE_APP_API_PREFIX + this.prefix + 'home/all/' + data + "?nowLimit=" + limit,
              method: "GET"
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function homeMessage(_x, _x2) {
      return _homeMessage.apply(this, arguments);
    }
    return homeMessage;
  }(),
  homeTop10Message: function () {
    var _homeTop10Message = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", request({
              showMask: true,
              url: process.env.VUE_APP_API_PREFIX + this.prefix + 'home/all/',
              method: "GET"
            }));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function homeTop10Message() {
      return _homeTop10Message.apply(this, arguments);
    }
    return homeTop10Message;
  }(),
  //首页消息数量
  homeMessageCount: function () {
    var _homeMessageCount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(data, log, loginTime) {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", request({
              showMask: true,
              url: process.env.VUE_APP_API_PREFIX + this.prefix + 'home/all/count/' + data + "?log=" + log + "&time=" + loginTime,
              method: "GET"
            }));
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
    function homeMessageCount(_x3, _x4, _x5) {
      return _homeMessageCount.apply(this, arguments);
    }
    return homeMessageCount;
  }(),
  //消息已读
  readMessage: function () {
    var _readMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(data) {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", request({
              showMask: true,
              url: process.env.VUE_APP_API_PREFIX + this.prefix + 'read?key=' + data,
              method: "GET"
            }));
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4, this);
    }));
    function readMessage(_x6) {
      return _readMessage.apply(this, arguments);
    }
    return readMessage;
  }(),
  //日历数据
  calendarData: function () {
    var _calendarData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(startDate, endDate) {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", request({
              showMask: true,
              url: process.env.VUE_APP_API_PREFIX + this.prefix + 'home/calendar/data?startDate=' + startDate + "&endDate=" + endDate,
              method: "GET"
            }));
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5, this);
    }));
    function calendarData(_x7, _x8) {
      return _calendarData.apply(this, arguments);
    }
    return calendarData;
  }()
};